import { Box } from '@mui/material';
import {useState} from 'react';
import MenuButton from '../MenuButton';
import AddButton from "../AddButton";
import DownloadButton from "../DownloadButton";
import SegmentButton from '../SegmentButton';
import SearchButton from "../SearchButton";
import FilterButton from "../FilterButton";
import ArrowCircleDownIcon from '@mui/icons-material/ExpandMore';
import ArrowCircleUpIcon from '@mui/icons-material/ExpandLess';
import "./TopBar.css";

interface TopBarProps {
    height?: number;
    showFilter?: boolean;
    multiOptionSelection?: boolean;
    multiOptionData?: Record<string, Record<string, string>>;
    multiOptionFilters?: any;
    multiOptionHeaderLabels?: string[];
    handleMultiOptionChange?: (key, value) => void;
    showSearch?: boolean;
    searchValue?: string;
    setSearchValue?: (value: string) => void;
    handleOnSearchChange?: (value: string) => void;
    showSegmentedButton?: boolean;
    selectedSegment?: string;
    setSelectedSegment?: any;
    segmentBarOptions?: any;
    handleSegmentClick?: (value: string) => void;
    showAdd?: boolean;
    handleAddClick?: () => void;
    showMenu?: boolean;
    menuItems?: string[];
    handleMenuItemClick?: (value: string) => void;
    showDownloadButton?: boolean;
    handleDownloadReport?: () => void;
    showCards?: boolean;
    defaultSelection?: string[];
    values?: string[];
    cardsCount?: number;
    handleSelection?: (value: string[]) => void;
    name?: string;
    limitValue?: number;
    justifySegment?: string;
    showCardCarrot?: boolean;
    openCard?: boolean;
    handleOpenCard?: () => void;
}
const TopBar = (props: TopBarProps) => {
    const {
        height = 32,
        showFilter,
        multiOptionSelection, 
        multiOptionData, 
        multiOptionFilters, 
        multiOptionHeaderLabels, 
        handleMultiOptionChange,
        showSearch,
        searchValue,
        setSearchValue,
        handleOnSearchChange,
        showSegmentedButton = false,
        selectedSegment,
        setSelectedSegment,
        segmentBarOptions,
        handleSegmentClick,
        showAdd=false,
        handleAddClick,
        showMenu=false,
        menuItems,
        handleMenuItemClick,
        showDownloadButton=false,
        handleDownloadReport,
        showCards,
        defaultSelection,
        values,
        cardsCount,
        handleSelection,
        name,
        limitValue,
        justifySegment,
        showCardCarrot=false,
        openCard=false,
        handleOpenCard
    } = props;
    return (
        <Box
            className="topbar-wrapper"
            sx={{
                position: 'relative',
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: { xs: 'center', sm: 'center' },
                justifyContent: 'space-between',
                width: '100%',
                flexWrap: 'wrap',
                gap: 2,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: 'center',
                    justifyContent: justifySegment ? justifySegment : 'unset',
                    gap: '24px',
                    flexWrap: 'wrap',
                    flex: 1,
                    minWidth: 0,
                }}
            >
                {showFilter && <FilterButton multiOptionSelection={multiOptionSelection} multiOptionData={multiOptionData} multiOptionFilters={multiOptionFilters} multiOptionHeaderLabels={multiOptionHeaderLabels} handleMultiOptionChange={handleMultiOptionChange} showCards={showCards} defaultSelection={defaultSelection} values={values} cardsCount={cardsCount} handleSelection={handleSelection} name={name} limitValue={limitValue}/>}
                {showSearch && <SearchButton height={height} searchValue={searchValue} setSearchValue={setSearchValue} handleOnSearchChange={handleOnSearchChange}/>}
                {showSegmentedButton && <SegmentButton selectedSegment={selectedSegment} setSelectedSegment={setSelectedSegment} segmentBarOptions={segmentBarOptions} handleSegmentClick={handleSegmentClick}/>}
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: { xs: 'flex-start', sm: 'flex-end' },
                    alignSelf: { xs: 'flex-start', sm: 'center' },
                    width: { xs: '100%', sm: 'auto' },
                    gap: '24px',
                    mt: { xs: 2, sm: 0 },
                }}
            >
                {showAdd && <AddButton handleAddClick={handleAddClick}/>}
                {showMenu && <MenuButton menuItems={menuItems} handleMenuItemClick={handleMenuItemClick}/>}
                {showDownloadButton && <DownloadButton handleDownloadReport={handleDownloadReport}/>}
                {showCardCarrot && (
                    openCard ?
                        <ArrowCircleUpIcon className="topbar-carrot" onClick={handleOpenCard} />
                        :
                        <ArrowCircleDownIcon className="topbar-carrot" onClick={handleOpenCard} />
                )}
            </Box>
        </Box>
    )
}

export default TopBar;